import { Component, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import {
  GcButtonComponent,
  GcInputFieldComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { GcHeaderComponent } from '../shared/gc-header/gc-header.component';
import { VideoInstructionCardComponent } from './video-instruction-card/video-instruction-card.component';
import {
  getVideosGroupedBySection,
  VIDEO_LIBRARY,
  VideoInstruction,
  VideoInstructionSectionGroup,
} from './video-instruction.entities';

@Component({
  selector: 'app-video-instruction',
  imports: [
    VideoInstructionCardComponent,
    GcButtonComponent,
    GcTextComponent,
    IpoTranslatePipe,
    GcInputFieldComponent,
    GcHeaderComponent,
  ],
  templateUrl: './video-instruction.component.html',
  styleUrl: './video-instruction.component.scss',
})
export class VideoInstructionComponent {
  private readonly router = inject(Router);

  readonly videos = signal<VideoInstruction[]>(VIDEO_LIBRARY);
  readonly videoSections = signal(getVideosGroupedBySection());
  readonly searchInputString = signal('');

  readonly noResultsFound = computed(() => {
    return (
      this.searchInputString().trim().length > 0 &&
      this.filteredVideoSections().length === 0
    );
  });

  readonly filteredVideoSections = computed(() => {
    const normalizedSearchStringInput = this.searchInputString();

    return this.getVideoSectionsMatchingSearchStringInput(
      normalizedSearchStringInput,
    );
  });

  private getVideoSectionsMatchingSearchStringInput(
    searchStringInput: string,
  ): VideoInstructionSectionGroup[] {
    if (!searchStringInput) {
      return this.videoSections();
    }

    return this.getSectionsWithVideosMatchingSearchTerm(
      this.videoSections(),
      searchStringInput,
    );
  }
  private getSectionsWithVideosMatchingSearchTerm(
    sections: VideoInstructionSectionGroup[],
    searchStringInput: string,
  ): VideoInstructionSectionGroup[] {
    return sections
      .map((sectionGroup) =>
        this.filterSectionVideosBySearchTerm(sectionGroup, searchStringInput),
      )
      .filter((sectionGroup) => sectionGroup.videos.length > 0);
  }

  private filterSectionVideosBySearchTerm(
    sectionGroup: VideoInstructionSectionGroup,
    searchStringInput: string,
  ): VideoInstructionSectionGroup {
    return {
      section: sectionGroup.section,
      videos: sectionGroup.videos.filter((video) =>
        video.title.toLowerCase().includes(searchStringInput),
      ),
    };
  }

  setSearchInputString(newTerm: string): void {
    this.searchInputString.set(newTerm.trim().toLowerCase());
  }

  goToHomePage() {
    this.router.navigate(['/home']);
  }
}
